module.exports = __webpack_public_path__ + "img/lit_hex_staker.7c8910e7.png";